import { isString } from 'lodash';
const htmlEntities = {
    '&#39;': "'",
    '&amp;': '&',
    '&gt;': '>',
    '&lt;': '<',
    '&quot;': '"',
};
const decodeHtml = (input) => input.replace(/&[\d#A-Za-z]+;/gu, (match) => htmlEntities[match] || match);
export const decodeString = (input, stripTags = false) => {
    if (isString(input)) {
        const decoded = decodeHtml(input);
        return stripTags ? decoded.replace(/(<([^>]+)>)/gu, '') : decoded;
    }
    return input;
};
//# sourceMappingURL=decodeString.js.map